import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  FETCH_TRANSACTIONS: "FETCH_TRANSACTIONS"
};

const fetchTransactions = async (state, transactions) => {
  state = {
    ...state,
    isStatus: transactions.status,
    expireToken: sanitizeExpire({
      status: transactions.status,
      data: transactions.data,
      name: "transactionsobj"
    }),
    data: sanitizeData({
      status: transactions.status,
      data: transactions.data,
      name: "transactionsobj"
    })
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TRANSACTIONS:
      return fetchTransactions(state, action.transactions);
    default:
      return state;
  }
};

const transactions = {
  init,
  actionTypes,
  reducer
};

export default transactions;
